import axios from "axios";
import { DEFAULT_PLACEMENT_JOB_DETAIL_LIST_VIEW_FIELDS } from "../../constants/default-values";
import tryGet from '../../utils/try-get'

const state = {
    listPlacementJobs: [],
    mapPlacementJobIdTitle: {}
};

const mutations = {
    setListPlacementJobs(state, payload) {
        state.listPlacementJobs = payload;
    },
    setMapPlacementJobIdTitle(state, payload) {
        state.mapPlacementJobIdTitle = payload;
    },
};

const actions = {
    setListPlacementJobs({ commit }, payload) {
        commit("setListPlacementJobs", payload);
    },
    loadPlacementJobList({ commit, state, rootState }) {
        return new Promise(async (resolve) => {
            if (state.listPlacementJobs && state.listPlacementJobs.length) {
                resolve();
                return;
            }
            const res = await axios.get(
                "/get-jobs/?job_type=Long Term&agency=" +
                rootState.authentication.agencyID.toString()
            );
            if (!res || !res.data) {
                resolve();
                return;
            }
            let listJobs = res.data.jobs;
            listJobs = listJobs.sort((a, b) =>
                a.id < b.id ? 1 : -1
            );
            commit("setListPlacementJobs", listJobs);
            resolve();
        });
    },
    async getPlacementJobById({ commit }, jobId) {
        const res = await axios.get(`/api/jobs/${jobId}/`);
        if (res && res.data) {
            return res.data;
        }
    },
    addMapPlacementJobIdTitle({ commit, state }, listJobs) {
        const currentMap = state.mapPlacementJobIdTitle || {};
        for (const job of listJobs) {
            currentMap[job.id] = job.title;
        }
        commit('setMapPlacementJobIdTitle', currentMap);
    }
};

const getters = {
    listPlacementJobs(state) {
        return state.listPlacementJobs;
    },
    mapPlacementJobIdTitle(state) {
        return state.mapPlacementJobIdTitle || {};
    },
    defaultPlacementJobApplicationStatusAddingRelationship(state, getters, rootState) {
        const agency = rootState.authentication.agency;
        if (agency && agency.advance_setting) {
            const listStatuses = agency.advance_setting.placement_application_status_auto_add_relationship_default;
            if (listStatuses) {
                return listStatuses;
            }
        }
        return [];
    },
    placementJobListDetailFields: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.placement_job_list_detail_fields) || DEFAULT_PLACEMENT_JOB_DETAIL_LIST_VIEW_FIELDS,
};

export default {
    state,
    mutations,
    actions,
    getters
};



// WEBPACK FOOTER //
// ./src/store/modules/placement-jobs.js